import React, { Component } from "react";
import { connect } from "react-redux";
import __ from "lodash";
import { CONFIG, URL_AKM } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import akmApi from "../../../../../apis/akmApi";
import { cekCookies } from "../../../../../actions";
import Loader from "../../../../Loader";
import LoaderModal from "../../../../modal/LoaderModal";
import PaginationData from "../../../../../entity/PaginationData";
import PaginationTable from "../../masterDropDown/PaginationTable";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import { Row, Col, Alert } from "react-bootstrap";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Collapse, Box, Button, ButtonGroup } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import JadwalForm from "../../akm/jadwal/JadwalForm";
import JadwalMapelForm from "../../akm/jadwal/JadwalMapelForm";
import dateFormat from "dateformat";
import Select from "react-select";
import moment from "moment";
// import moment from "moment-timezone";

class JadwalProfilCbt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      isSearch: false,
      openDialog: false,
      alertShow: false,
      resMessage: "Error",
      tipeCbt: null,
      listProfil: [],
      listJadwal: [],
      profil: {},
      jadwal: {},
      paginationData: PaginationData,
      addJadwal: false,
      addJadwalSub: false,
      listArrayKodeTipeCbt: ["TRYOUT", "AGCU", "AKM", "PEMINATAN", "SBMPTN", "PEMETAAN", "PEMETAAN2", "PEMETAAN3", "ENSA"],
      listKodeTipe: [],
    };
  }
  async componentDidMount() {
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account) && this.state.tipeCbt != null) {
      this.fetchProfil(this.state.tipeCbt, this.state.namaProfil);
    }
    if (this.props.location.state !== undefined) {
      let profilProps = this.props.location.state.profil;
      profilProps.open = false;
    }

    this.state.listArrayKodeTipeCbt.map((cbt, i) => {
      const kodeTipe = { value: cbt, label: cbt, id: "kodeTipeCbt" };
      this.state.listKodeTipe.push(kodeTipe);
    });
  }

  fetchProfil = async (tipe, nama) => {
    this.setState({ isSearch: true, listProfil: [] });
    const result = await akmApi.post(URL_AKM.PROFIL_LIST + "?page=" + this.state.paginationData.page + "&size=" + this.state.paginationData.size, {
      kodeSubTipeCbt: tipe,
      namaProfil: nama,
    });
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listProfil: result.data.data.content,
          paginationData: {
            ...this.state.paginationData,
            page: result.data.data.number,
            size: result.data.data.size,
            totalPages: result.data.data.totalPages,
            numberOfElements: result.data.data.numberOfElements,
            totalElements: result.data.data.totalElements,
          },
        });
      } else {
        this.setState({
          alertShow: true,
          resMessage: result.data.errorSchema.errorMessage,
        });
      }
      this.setState({ isSearch: false });
    }
  };

  loadAlert = () => {
    const { alertShow } = this.state;
    if (alertShow) {
      return (
        <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{this.state.resMessage}</strong>
        </Alert>
      );
    }
  };

  setOpen = async (profil) => {
    this.setState((state) => ({
      ...state,
      listProfil: this.state.listProfil.map((item) => (item.idProfilCbt === profil.idProfilCbt ? { ...item, open: !profil.open } : { ...item, open: false })),
    }));
    if (!profil.open) {
      this.fetchJadwal(profil.idProfilCbt);
    }
  };

  fetchJadwal = async (idProfil) => {
    this.setState({ isFetching: true, listJadwal: [] });

    const response = await akmApi.get(URL_AKM.GET_JADWAL_BY_IDPROFIL + idProfil).catch(function (error) {
      alert(error);
    });

    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listJadwal: response.data.data,
        });
      }
      this.setState({ isFetching: false });
    }
  };

  scopeJadwal(jadwal) {
    if (jadwal.idSekolah !== null) {
      return <span>{jadwal.namaSekolah}</span>;
    } else if (jadwal.idDinas !== null) {
      return <span>{jadwal.namaDinas}</span>;
    }
    return <span>ALL</span>;
  }

  addJadwal(profil) {
    this.setState({
      addJadwal: true,
      addJadwalSub: false,
      alertShow: false,
      profil: { ...profil, idAdmin: this.props.account.idAdmin },
      jadwal: {},
    });
  }
  editJadwal(profil, jadwal) {
    this.setState({
      addJadwal: true,
      addJadwalSub: false,
      alertShow: false,
      profil: { ...profil, idAdmin: this.props.account.idAdmin },
      jadwal: jadwal,
    });
  }
  addJadwalSub(profil, jadwal) {
    this.setState({
      addJadwalSub: true,
      addJadwal: false,
      alertShow: false,
      profil: { ...profil, idAdmin: this.props.account.idAdmin },
      jadwal: jadwal,
    });
  }

  deleteJadwal = async (id) => {
    this.setState({ isFetching: true, openDialog: false });
    const response = await accountManagement.post(CONFIG.EXAM_JADWAL_DELETE + id).catch(function (error) {
      alert(error);
    });
    const { listJadwal } = this.state;
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listJadwal: listJadwal.filter((jadwal) => jadwal.idJadwalProfilCbt !== id),
        });
      }
      this.setState({
        resMessage: response.data.errorSchema.errorMessage,
        isFetching: false,
        alertShow: true,
      });
    }
  };

  formatDate(date) {
    // return <small>{dateFormat(date, "dd mmmm yyyy, HH:mm")}</small>;
    return <small>{moment(date).format("DD-MM-YYYY HH:mm")}</small>;
  }

  renderRow() {
    return (
      <>
        {this.state.listProfil.map((profil) => (
          <React.Fragment key={profil.idProfilCbt}>
            <TableRow>
              <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={() => this.setOpen(profil)}>
                  {profil.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
              <TableCell align="left">{profil.namaProfil.split("~")[0]}</TableCell>
              <TableCell align="left">
                {profil.idKurikulum == 3 && "K-13 REVISI"}
                {profil.idKurikulum == 2 && "K-13"}
                {profil.idKurikulum == 1 && "KTSP"}
              </TableCell>
              <TableCell align="left">{profil.namaProfil.split("~")[1]}</TableCell>
              <TableCell align="right">
                <div className="button-group">
                  <button className="btn btn-primary btn-sm" onClick={() => this.addJadwal(profil)}>
                    tambah
                  </button>
                </div>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={profil.open} timeout="auto" unmountOnExit>
                  <Box margin={1}>
                    <TableCell component="th" scope="row">
                      <h5>List Jadwal</h5>
                    </TableCell>
                    <Table size="small" aria-label="jadwal">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nama Jadwal</TableCell>
                          <TableCell align="center">Scope</TableCell>
                          <TableCell align="center">Tahun</TableCell>
                          <TableCell align="center">Start/End</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.listJadwal.map((jdw) => (
                          <TableRow key={jdw.idJadwalProfilCbt}>
                            <TableCell component="th" scope="row">
                              {jdw.namaJadwalCbt}
                            </TableCell>
                            <TableCell align="center">{this.scopeJadwal(jdw)}</TableCell>
                            <TableCell align="center">{jdw.kodeTahunAjaran}</TableCell>

                            <TableCell align="center">
                              {this.formatDate(jdw.jadwalMulai)} /<br /> {this.formatDate(jdw.jadwalSelesai)}
                            </TableCell>
                            <TableCell align="right">
                              <ButtonGroup variant="text" size="small" aria-label="text primary button group">
                                <Button style={{ color: "#343a40" }} onClick={() => this.addJadwalSub(profil, jdw)}>
                                  Jadwal Mapel
                                </Button>
                                <Button style={{ color: "#ffc107" }} onClick={() => this.editJadwal(profil, jdw)}>
                                  edit
                                </Button>
                                <Button style={{ color: "#dc3545" }} onClick={() => this.showDialog(jdw)}>
                                  hapus
                                </Button>
                              </ButtonGroup>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}
      </>
    );
  }

  loading = () => {
    if (this.state.isSearch) {
      return <Loader />;
    }
  };

  handleChangePage = async (newPage) => {
    this.state.paginationData.page = newPage;
    this.fetchProfil(this.state.tipeCbt, this.state.namaProfil);
  };

  handleChangeRowsPerPage = (size) => {
    this.state.paginationData.page = 0;
    this.state.paginationData.size = size;
    this.fetchProfil(this.state.tipeCbt, this.state.namaProfil);
  };

  submitJadwal = async (data) => {
    this.setState({ isFetching: true });
    const response = await accountManagement.post(CONFIG.EXAM_JADWAL_SAVE, data).catch(function (error) {
      alert(error);
    });
    const { listJadwal } = this.state;
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState((state) => ({
          ...state,
          listProfil: this.state.listProfil.map((item) => (item.idProfilCbt == data.idProfil ? { ...item, open: true } : { ...item, open: false })),
        }));
        this.fetchJadwal(data.idProfil);
        this.setState({ addJadwal: false });
      }
      this.setState({
        resMessage: response.data.errorSchema.errorMessage,
        isFetching: false,
        alertShow: true,
      });
    }
  };

  submitJadwalSub = async (data, idProfil) => {
    this.setState({ isFetching: true });
    const response = await accountManagement.post(CONFIG.EXAM_JADWAL_SUB_SAVE, data).catch(function (error) {
      alert(error);
    });

    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({ addJadwalSub: false });
        this.setState((state) => ({
          ...state,
          listProfil: this.state.listProfil.map((item) => (item.idProfilCbt == idProfil ? { ...item, open: true } : { ...item, open: false })),
        }));
        this.fetchJadwal(idProfil);
      }
      this.setState({
        resMessage: response.data.errorSchema.errorMessage,
        isFetching: false,
        alertShow: true,
      });
    }
  };

  handleChangeSelect = async (e) => {
    const value = e.value;
    this.setState({ tipeCbt: value });
    this.fetchProfil(value, this.state.namaProfil);
  };

  handleOnChangeList = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const tipe = this.props.kodeTipeCbt;

    this.setState({
      [name]: value,
      isSearch: true,
      alertShow: false,
    });

    // searchProfil
    if (name === "namaProfil") {
      this.fetchProfil(this.state.tipeCbt, value);
    }
  };

  render() {
    const { addJadwal, addJadwalSub, tipeCbt, listKodeTipe } = this.state;
    let formJadwal, formJadwalSub;
    if (addJadwal) {
      formJadwal = <JadwalForm submitJadwal={this.submitJadwal} jadwal={this.state.jadwal} profil={this.state.profil} handleBack={this.handleBack} />;
    } else if (addJadwalSub) {
      formJadwalSub = <JadwalMapelForm submitJadwalSub={this.submitJadwalSub} handleBack={this.handleBack} jadwal={this.state.jadwal} profil={this.state.profil} />;
    }
    return (
      <div className="wrapper">
        <LoaderModal isFetching={this.state.isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar title={tipeCbt != null ? "Mgt Jadwal " + tipeCbt : "Silahkan pilih Tipe Cbt dulu ..."} />
          <Row>
            <Col sm={9}>
              <Select options={listKodeTipe} onChange={this.handleChangeSelect} placeholder="Pilih Tipe Cbt..." />
              <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={tipeCbt} />
            </Col>
            <Col style={{ "text-align": "right" }} sm={3}>
              <input type="text" className="form-control" name="namaProfil" id="namaProfil" onChange={this.handleOnChangeList} />
            </Col>
          </Row>
          {this.loading()}
          {this.loadAlert()}
          <Row>
            <Col>
              {this.state.listProfil.length !== 0 && !(formJadwal || formJadwalSub) && (
                <>
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell align="left">Judul</TableCell>
                          <TableCell align="left">Kurikulum</TableCell>
                          <TableCell align="left">Kelas Group</TableCell>
                          <TableCell align="right">#Aksi</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{this.renderRow()}</TableBody>
                    </Table>
                    <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                  </TableContainer>
                </>
              )}
            </Col>
          </Row>
          {formJadwal}
          {formJadwalSub}
        </div>

        {this.confirmDialog()}
      </div>
    );
  }

  handleProfilDialog = (data) => {
    this.setState({ isHapusProfil: true, isHapusjdw: false, hapusData: data });
  };
  handleSubProfilDialog = (data) => {
    this.setState({ isHapusProfil: false, isHapusjdw: true, hapusData: data });
  };

  showDialog = (jadwal) => {
    this.setState({
      openDialog: true,
      jadwal: jadwal,
    });
  };
  handleBack = () => {
    this.setState({ addJadwal: false, addJadwalSub: false });
  };

  confirmDialog() {
    const { openDialog, jadwal } = this.state;
    const handleClose = () => {
      this.setState({ openDialog: false });
    };
    return (
      <>
        <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Konfirmasi Hapus?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Menghapus Jadwal juga akan menghapus report Siswa
              <br />
              Yakin akan menghapus <strong>{jadwal.namaJadwal}</strong> ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button className="btn btn-danger" onClick={handleClose}>
              {" "}
              Tidak{" "}
            </button>
            <button className="btn btn-primary" onClick={() => this.deleteJadwal(jadwal.idJadwalProfilCbt)} autoFocus>
              {" "}
              Ya{" "}
            </button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};
export default connect(mapStateToProps, { cekCookies })(JadwalProfilCbt);
